<mat-card *ngIf="keyFigure && year && user">

  <div class="wizard-buttons-container align-right">
    <button mat-raised-button (click)="print()" color="primary">
      <mat-icon class="material-icons-outlined">print</mat-icon>
      <span>Print</span>
    </button>
    <button mat-raised-button (click)="printLastYear()" [disabled]="!existsPreviousYear">
      <mat-icon class="material-icons-outlined">print</mat-icon>
      <span>Last year</span>
    </button>
  </div>
  <mat-card-title>
    <h1>
      <span class="key-figure">{{keyFigure}} {{year}}
        | </span><span>{{this.country ? user.weeeSystem.country.name : user.weeeSystem.description}}</span>
      <app-help-icon-button *ngIf="this.country"
                            [code]="this.keyFigure === 'Put On Market' ? 'keyfigureentry.Country.PutOnMarket.detail' : 'keyfigureentry.Country.Collected.detail'"></app-help-icon-button>
      <app-help-icon-button *ngIf="!this.country"
                            [code]="this.keyFigure === 'Put On Market'
          ? 'keyfigureentry.WeeeSystem.PutOnMarket.detail'
          : (this.keyFigure === 'Collected'
              ? 'keyfigureentry.WeeeSystem.Collected.detail'
              : (this.keyFigure === 'Cost'
                ? 'keyfigureentry.WeeeSystem.Cost.detail'
                : 'keyfigureentry.WeeeSystem.Recycling.detail'))">
      </app-help-icon-button>
    </h1>


    <mat-stepper>
      <mat-step>
        <ng-template matStepLabel>General Info</ng-template>
        <form class="form-search-bar" [formGroup]="generalInfoForm" (ngSubmit)="generalSubmit()">
          <mat-form-field class="full-width-input" appearance="outline" color="primary">
            <mat-label>Estimation / Determined</mat-label>
            <mat-select [formControl]="estimatedDeterminedControl">
              <mat-option value="ESTIMATION"> Estimation</mat-option>
              <mat-option value="DETERMINED"> Determined</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="full-width-input" appearance="outline" color="primary"
                          *ngIf="keyFigure !== 'Recycling'">
            <mat-label>B2B / B2C</mat-label>
            <mat-select [formControl]="b2bb2cControl">
              <mat-option value="UNDIFFERENTIATED"> Undifferentiated</mat-option>
              <mat-option value="DIFFERENTIATED"> Differentiated</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="full-width-input" appearance="outline" color="primary" *ngIf="keyFigure !== 'Recycling'">
            <mat-label>B2B in your report includes (select more than one option if necessary)</mat-label>
            <mat-select [formControl]="b2bIncludesControl" multiple>
              <mat-option *ngFor="let option of b2bIncludes" [value]="option">{{option}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="full-width-input" appearance="outline" color="primary"
                          *ngIf="country">
            <mat-label>Source</mat-label>
            <mat-select [formControl]="sourceControl">
              <mat-option *ngFor="let source of registrationSources"
                          [value]="source"> {{source.description}}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="general-info-checkbox">
            <mat-checkbox class="no-data"
                          [checked]="kfRegistrationDetail?.kfRegistration?.noDataReport === true || newKfRegistrationDetail.kfRegistration.noDataReport === true"
                          [formControl]="confidentialControl">
              Data is confidential and will not be reported
            </mat-checkbox>

            <ng-template
              [ngIf]="(this.keyFigure === 'Collected' || this.keyFigure === 'Cost') && router.url.includes('weeesystem')">
              <mat-checkbox [checked]="kfRegistrationDetail?.kfRegistration?.clearedWeee === true"
                            matTooltip="If you will include WEEE in your report that has been collected by another PRO but belongs under your PRO´s obligation and you compensated them for it financially or other ways, please tick this box."
                            [formControl]="clearedWeeeControl">
                Reported collection includes cleared WEEE
              </mat-checkbox>
              <mat-hint>
                Please indicate in “Remarks” of each category if amount includes cleared WEEE
              </mat-hint>
            </ng-template>
          </div>

          <mat-form-field class="full-width-input" appearance="outline" color="primary">
            <mat-label>My notes (only I and WEEE Forum administrator can see them)</mat-label>
            <textarea [formControl]="notesControl" matInput>Notes</textarea>
          </mat-form-field>
          <div class="info-checkers">
            <mat-checkbox *ngIf="kfRegistrationDetail?.kfRegistration?.completionStatus" disabled [checked]="true">
              Completed by member
            </mat-checkbox>
            <mat-checkbox *ngIf="kfRegistrationDetail?.kfRegistration?.validationStatus" disabled [checked]="true">
              Validated by WEEE-Forum
            </mat-checkbox>
          </div>

          <div class="wizard-buttons-container align-right">
            <button mat-raised-button matStepperPrevious disabled>
              <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
              <span>Back</span>
            </button>
            <button *ngIf="!confidentialControl.value" mat-raised-button matStepperNext type="submit" color="primary">
              <span>Next</span>
              <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
            </button>
            <button *ngIf="confidentialControl.value === true" (click)="markAsConfidential()" mat-raised-button color="primary">
              <span>Save</span>
              <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
            </button>
          </div>
        </form>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Entries</ng-template>
        <div class="table-container" *ngIf="categories.length > 0">
          <app-kf-registration-edit-table-undifferentiated
            *ngIf="b2bb2cControl.value === 'UNDIFFERENTIATED' && (keyFigure === 'Put On Market' || keyFigure === 'Collected')"
            [kfRegistrationDetail]="kfRegistrationDetail"
            [originalDetailLevel]="originalDetailLevel"
            [newKfRegistrationDetail]="newKfRegistrationDetail"
            [categories]="categories"
            [b2bb2c]="b2bb2cControl.value"
            [country]="country"
            [year]="year"
            [keyFigure]="keyFigure"
            [user]="user"
            (markAsCompletedEmitter)="markAsCompleted()"
            (markAsCompletedWarningEmitter)="markAsCompletedWarning()"
            (resetEmitter)="reset()"
            (redirectUrlEmitter)="redirectUrl($event)">
          </app-kf-registration-edit-table-undifferentiated>

          <app-kf-registration-edit-table-differentiated
            *ngIf="b2bb2cControl.value === 'DIFFERENTIATED' && (keyFigure === 'Put On Market' || keyFigure === 'Collected')"
            [kfRegistrationDetail]="kfRegistrationDetail"
            [originalDetailLevel]="originalDetailLevel"
            [newKfRegistrationDetail]="newKfRegistrationDetail"
            [categories]="categories"
            [b2bb2c]="b2bb2cControl.value"
            [country]="country"
            [year]="year"
            [keyFigure]="keyFigure"
            [user]="user"
            (markAsCompletedEmitter)="markAsCompleted()"
            (markAsCompletedWarningEmitter)="markAsCompletedWarning()"
            (resetEmitter)="reset()"
            (redirectUrlEmitter)="redirectUrl($event)">
          </app-kf-registration-edit-table-differentiated>

          <app-kf-registration-edit-table-cost-undifferentiated
            *ngIf="b2bb2cControl.value === 'UNDIFFERENTIATED' && keyFigure === 'Cost'"
            [kfRegistrationDetail]="kfRegistrationDetail"
            [newKfRegistrationDetail]="newKfRegistrationDetail"
            [categories]="categories"
            [b2bb2c]="b2bb2cControl.value"
            [currencies]="currencies"
            (markAsCompletedEmitter)="markAsCompleted()"
            (resetEmitter)="reset()"
            (redirectUrlEmitter)="redirectUrl($event)">
          </app-kf-registration-edit-table-cost-undifferentiated>

          <app-kf-registration-edit-table-cost-differentiated
            *ngIf="b2bb2cControl.value === 'DIFFERENTIATED' && keyFigure === 'Cost'"
            [kfRegistrationDetail]="kfRegistrationDetail"
            [newKfRegistrationDetail]="newKfRegistrationDetail"
            [categories]="categories"
            [b2bb2c]="b2bb2cControl.value"
            [currencies]="currencies"
            (markAsCompletedEmitter)="markAsCompleted()"
            (resetEmitter)="reset()"
            (redirectUrlEmitter)="redirectUrl($event)">
          </app-kf-registration-edit-table-cost-differentiated>

          <app-kf-registration-edit-table-recycling *ngIf="keyFigure === 'Recycling' && categories.length > 0"
                                                    [kfRegistrationDetail]="kfRegistrationDetail"
                                                    [newKfRegistrationDetail]="newKfRegistrationDetail"
                                                    [categories]="categories"
                                                    (markAsCompletedEmitter)="markAsCompleted()"
                                                    (resetEmitter)="reset()"
                                                    (redirectUrlEmitter)="redirectUrl($event)">
          </app-kf-registration-edit-table-recycling>

        </div>
      </mat-step>
    </mat-stepper>
  </mat-card-title>
</mat-card>
